import OrderList from '../pages/Orders/OrderList';
import OrderDetail from '../pages/Orders/OrderDetail';
import { ALL_ROLES } from '../constants/roles';
import RoleProtectedRoute from '../components/RoleProtectedRoute';
import type { AppRoute } from './types';

export const ordersRoutes: AppRoute[] = [
    {
        path: 'orders',
        children: [
            { index: true, element: <RoleProtectedRoute allowedRoles={ALL_ROLES} Component={OrderList} /> },
            { path: ':id', element: <RoleProtectedRoute allowedRoles={ALL_ROLES} Component={OrderDetail} /> },
        ],
    },
];
